import React from 'react';
import { CopyCard } from './adminSiteCopyFields';
import { slugifyBespokeOptionValue } from '../content/bespokeFormNormalize';

function OptionRow({ option, index, onChange, onRemove, idPrefix }) {
  return (
    <div className="row g-2 align-items-end mb-2">
      <div className="col-md-6">
        <label className="form-label small mb-1" htmlFor={`${idPrefix}-label-${index}`}>
          Button label
        </label>
        <input
          id={`${idPrefix}-label-${index}`}
          className="form-control form-control-sm"
          value={option.label}
          onChange={(e) => {
            const label = e.target.value;
            const patch = { label };
            if (!option.value || option.value.startsWith('option-')) {
              const slug = slugifyBespokeOptionValue(label);
              if (slug) patch.value = slug;
            }
            onChange(patch);
          }}
          placeholder="e.g. Haldi"
        />
      </div>
      <div className="col-md-4">
        <label className="form-label small mb-1" htmlFor={`${idPrefix}-value-${index}`}>
          Value (slug)
        </label>
        <input
          id={`${idPrefix}-value-${index}`}
          className="form-control form-control-sm font-monospace"
          value={option.value}
          onChange={(e) =>
            onChange({
              value: String(e.target.value || '')
                .trim()
                .toLowerCase()
                .replace(/[^a-z0-9_-]/g, ''),
            })
          }
          placeholder="haldi"
        />
      </div>
      <div className="col-md-2">
        <button type="button" className="btn btn-outline-danger btn-sm w-100" onClick={onRemove}>
          Remove
        </button>
      </div>
    </div>
  );
}

export default function AdminBespokeFormOptionsEditor({
  title,
  subtitle,
  options,
  defaults,
  onChange,
  idPrefix,
}) {
  const list = Array.isArray(options) ? options : defaults;

  const updateAt = (index, patch) => {
    onChange(list.map((item, i) => (i === index ? { ...item, ...patch } : item)));
  };

  const addOption = () => {
    const n = list.length + 1;
    onChange([...list, { value: `option-${n}`, label: 'New option' }]);
  };

  const resetDefaults = () => {
    onChange(defaults.map((item) => ({ ...item })));
  };

  return (
    <CopyCard title={title} subtitle={subtitle}>
      {list.length === 0 ? (
        <p className="col-12 small text-muted mb-2">No options — add at least one or reset to defaults.</p>
      ) : null}
      <div className="col-12">
        {list.map((opt, index) => (
          <OptionRow
            key={`${idPrefix}-${opt.value}-${index}`}
            idPrefix={idPrefix}
            index={index}
            option={opt}
            onChange={(patch) => updateAt(index, patch)}
            onRemove={() => onChange(list.filter((_, i) => i !== index))}
          />
        ))}
      </div>
      <div className="col-12 d-flex flex-wrap gap-2 mt-1">
        <button type="button" className="btn btn-sm btn-outline-primary" onClick={addOption}>
          Add option
        </button>
        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={resetDefaults}>
          Reset to defaults
        </button>
      </div>
      <p className="col-12 small text-muted mb-0">
        Labels appear as buttons on <code>/custom-jewelry</code>. Keep slugs stable — changing a slug does not update
        old requests.
      </p>
    </CopyCard>
  );
}
